'use client';

import type { TDynamicData } from '@eliadmin/core/src/types/dynamic-data';

import { fetchDynamicSections } from '@eliadmin/core/src/api/dynamics/dynamics-api';
import { useQuery } from '@tanstack/react-query';
import { MemberZoneFile } from '../member-zone-file';
import { FilesSkeleton } from '../files-skeleton';
import { Input } from '../../ui/input';
import { CiSearch } from 'react-icons/ci';
import { useState } from 'react';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function RecievablesTab({ locale }: { locale: string }) {
  const { t } = useTranslations();
  const [searchTerm, setSearchTerm] = useState('');

  const { data: files = [], isLoading } = useQuery({
    queryKey: ['RECIEVABLES', locale, searchTerm],
    queryFn: () =>
      fetchDynamicSections<TDynamicData>({
        locale,
        sectionIds: [9],
        query: {
          search: searchTerm || undefined,
        },
      }),
  });

  return (
    <>
      <div className="grid w-full grid-cols-1 gap-2.5 lg:grid-cols-2">
        <Input
          type="text"
          placeholder={t('text211')}
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          before={<CiSearch size={20} className="ml-4 text-primary" />}
          className={{
            main: 'col-span-1 h-[50px] w-full rounded-full bg-black/5 pl-12 text-sm text-primary placeholder-primary',
            wrapper: 'col-span-1 h-[50px] w-full rounded-full bg-transparent',
          }}
        />
      </div>
      {isLoading ? (
        <FilesSkeleton />
      ) : (
        <div className="flex w-full flex-col items-start justify-start gap-2.5">
          {files.map(file => (
            <MemberZoneFile
              item={file}
              key={file.id}
              showPrint={true}
              showDownload={true}
              showCreatedAt={false}
            />
          ))}
        </div>
      )}
    </>
  );
}
